// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2JML7","footer":"styles_footer__24K4e","passCodeTooltip":"styles_passCodeTooltip__3Q9RY"};